import { useBlockProps } from '@wordpress/block-editor';

export default function Save({ attributes }) {
  const { slides, padding, colorbg, title, url, positiontitle, container } =
    attributes;
  const blockProps = useBlockProps.save({
    className: `why ${colorbg ? 'sectiongray' : ''} ${padding}`,
  });
  const Tag = title ? 'section' : 'div';

  return (
    <>
      {slides && (
        <Tag {...blockProps}>
          <div className={container ? '' : 'container'}>
            {title && (
              <div class="row">
                <div className={`globaltitle ${positiontitle}`}>
                  <h2>{title}</h2>
                  {url && (
                    <a href={url} class="btn btn-square btn-mini btn-url">
                      Смотреть все изделия
                    </a>
                  )}
                </div>
              </div>
            )}
            <div class="row g-4">
              {slides.map((slide, index) => (
                <div class="col-lg-6">
                  <div class="why__item">
                    <div class="why__item-ico">
                      <img
                        loading="lazy"
                        src={slide.image.url}
                        alt={slide.image.alt}
                        height={slide.image.height}
                        width={slide.image.width}
                      />
                    </div>
                    <div class="why__item-content">
                      <div class="why__item-content-title">{slide.title}</div>
                      <div class="why__item-content-desc">
                        {slide.description}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Tag>
      )}
    </>
  );
}
